function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242"
    },
    d: "M16.159,18.072c0,0.396-0.321,0.717-0.717,0.717H9.37c-0.396,0-0.717-0.321-0.717-0.717 s0.321-0.717,0.717-0.717h2.319v-5.81H9.37c-0.396,0-0.717-0.321-0.717-0.717s0.321-0.717,0.717-0.717h3.036 c0.396,0,0.717,0.321,0.717,0.717v6.527h2.319C15.838,17.355,16.159,17.676,16.159,18.072z M12.119,7.817 c0.845,0,1.53-0.685,1.53-1.53s-0.685-1.53-1.53-1.53c-0.845,0-1.53,0.685-1.53,1.53S11.275,7.817,12.119,7.817z M24,12 c0,6.617-5.383,12-12,12S0,18.617,0,12S5.383,0,12,0S24,5.383,24,12z M22.567,12c0-5.827-4.74-10.567-10.567-10.567 S1.433,6.173,1.433,12S6.173,22.567,12,22.567S22.567,17.827,22.567,12z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.803bf918.svg";
export { ForwardRef as ReactComponent };